import {
  AreaHighlight,
  MonitoredHighlightContainer,
  type Tip,
  useHighlightContainerContext,
} from 'react-pdf-highlighter-extended';
import HighlightPopup from './HighlightPopup';
import { TextHighlight } from './TextHighlight';
import type { CommentedHighlight } from './types';

const HighlightContainer = () => {
  const { highlight, isScrolledTo, highlightBindings } =
    useHighlightContainerContext<CommentedHighlight>();

  const isTextHighlight = highlight.type === 'text';

  const component = isTextHighlight ? (
    <TextHighlight isScrolledTo={isScrolledTo} highlight={highlight} />
  ) : (
    <AreaHighlight
      isScrolledTo={isScrolledTo}
      highlight={highlight}
      bounds={highlightBindings.textLayer}
    />
  );

  const highlightTip: Tip = {
    position: highlight.position,
    content: <HighlightPopup highlight={highlight} />,
  };

  return (
    <MonitoredHighlightContainer highlightTip={highlightTip} key={highlight.id}>
      {component}
    </MonitoredHighlightContainer>
  );
};

export default HighlightContainer;
